import api from './api';

export interface Setting {
  id: number;
  setting_type: string;
  setting_key: string;
  setting_value: string;
  display_name: string;
  color_code?: string;
  description?: string;
  display_order: number;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface CreateSettingData {
  setting_type: string;
  setting_key: string;
  setting_value: string;
  display_name: string;
  color_code?: string;
  description?: string;
  display_order?: number;
  is_active?: boolean;
}

export interface UpdateSettingData extends Partial<CreateSettingData> {}

export const settingService = {
  getAll: async (filters?: { setting_type?: string; is_active?: boolean }): Promise<Setting[]> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
    }
    const response = await api.get(`/api/settings?${params.toString()}`);
    return response.data.data || [];
  },

  getByType: async (
    type: string,
    includeInactive = false,
    settingKey?: string,
    settingValue?: string
  ): Promise<Setting[]> => {
    const params = new URLSearchParams();
    if (includeInactive) {
      params.append('include_inactive', 'true');
    }
    if (settingKey) {
      params.append('setting_key', settingKey);
    }
    if (settingValue) {
      params.append('setting_value', settingValue);
    }
    const queryString = params.toString();
    const response = await api.get(`/api/settings/type/${type}${queryString ? `?${queryString}` : ''}`);
    return response.data.data || [];
  },

  getById: async (id: number): Promise<Setting> => {
    const response = await api.get(`/api/settings/${id}`);
    return response.data.data;
  },

  create: async (settingData: CreateSettingData): Promise<Setting> => {
    const response = await api.post('/api/settings', settingData);
    return response.data.data;
  },

  update: async (id: number, settingData: UpdateSettingData): Promise<Setting> => {
    const response = await api.put(`/api/settings/${id}`, settingData);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/settings/${id}`);
  },
};




